export default __webpack_public_path__ + "static/media/base.e26a76f0.psd";